/* eslint-disable import/prefer-default-export */
import { setItem, removeItem } from './local-storage';

export const broadcastMessageToTabs = (key, value) => {
  setItem(key, value);
  removeItem(key);
};
